import React, { useEffect, useState } from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import moment from "moment";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";

import { fetchCustomerDetails } from "../../redux/slice/customerDetails";
import { updateCustomerCall, reset } from "../../redux/slice/editProfile";

import "./editProfile.scss";
import Header from "../../component/header/Header";
import Aside from "../../component/aside/Aside";
import Footer2 from "../../component/footer/Footer2";
import Spinner from "../../component/spinner/Spinner";
import { getFieldsValue } from "../../utils/common";
import states from "../../utils/state";
import closeIcon from "../../assets/images/modelClosIcon.svg";
import user_Icon from "../../assets/images/userIcon.svg";
// import camera_Icon from "../../assets/images/camera.svg";
import flag from "../../assets/images/IN.svg";
import calendarIocn from "../../assets/images/Calendar.svg";
// import LocateIcon from "../../assets/images/locate.svg";
import CustomDatePicker from "../../component/CustomDatePicker";
// import { AppContext } from "../../utils/context";

const EditProfile = () => {
  // const { mobile } = useContext(AppContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    // updateCustomerData,
    loading,
    // success,
  } = useSelector((state) => state.updateCustomer);
  const { customerDetailsData } = useSelector((state) => state.customerDetails);
  const [isDOBPresent, setIsDOBPresent] = useState(true);

  useEffect(() => {
    if (
      getFieldsValue(customerDetailsData?.extended_fields?.field, "dob_date")
    ) {
      setIsDOBPresent(true);
    } else {
      setIsDOBPresent(false);
    }

    // eslint-disable-next-line
  }, [customerDetailsData]);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Please enter a valid email address.")
      .matches(
        // Pattern follows RFC 5322 and RFC 1035 reasonable constraints for real-world emails
        /^(?!.*\.\.)(?!.*\.$)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Please enter a valid email address."
      ),
    // .required("Email ID is required."),
    // mobile: Yup.string()
    //   .required("Mobile number is required.")
    //   .min(3, "Please provide the country code")
    //   .matches(
    //     /^\+91[0-9]{10}$/,
    //     "Mobile number must be in the format +91XXXXXXXXXX"
    //   ),
    firstname: Yup.string()
      .matches(
        /^[a-zA-Z\s'-]+$/,
        "Only alphabetic characters, hyphens, apostrophes, and spaces are allowed"
      )
      .max(50, "Maximum 50 characters allowed")
      .required("First Name is required."),
    lastname: Yup.string()
      .matches(
        /^[a-zA-Z\s'-]+$/,
        "Only alphabetic characters, hyphens, apostrophes, and spaces are allowed"
      )
      .max(50, "Maximum 50 characters allowed")
      .required("Last Name is required."),
    gender: Yup.string().required("Gender  is required."),
    dob: Yup.date()
      .nullable()
      .max(new Date(), "Date of birth cannot be in the future")
      .required("Date of Birth is required."),
    address1: Yup.string().required("Address Line  is required."),
    // address2: Yup.string().required("Address Line 2 is required."),
    state: Yup.string().required("State is required."),
    pincode: Yup.string()
      .required("Pin Code is required.")
      .matches(/^\d{6}$/, "Pin Code must be 6 digits."),
    // addressType: Yup.string().required("Address Type is required."),
  });

  useEffect(() => {
    dispatch(fetchCustomerDetails());
    return () => {
      dispatch(reset());
    };
    // eslint-disable-next-line
  }, []);

  const [activeTab, setActiveTab] = useState("v-pills-home");
  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => navigate("/home")}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#1D1D1B",
      }}
    >
      Home
    </Link>,
    <Link
      underline="hover"
      key="2"
      color="inherit"
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#1D1D1B",
      }}
    >
      My Profile
    </Link>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#1D1D1B",
      }}
    >
      Edit Profile
    </Typography>,
  ];
  const breadcrumbsMobile = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => navigate("/home")}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#A9A9A9",
      }}
    >
      Home
    </Link>,
    <Link
      underline="hover"
      key="2"
      color="inherit"
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#A9A9A9",
      }}
    >
      My Profile
    </Link>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#ffffff",
      }}
    >
      Edit Profile
    </Typography>,
  ];
  return (
    <>
      <Header activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className="home">
        <div className="container pt-5 in-mobile desktop_content">
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            {breadcrumbs}
          </Breadcrumbs>
        </div>
        <div className="sidebar pt-5 in-mobile">
          <div className="container">
            <div className="row">
              <div className="col-lg-4  col-md-4 desktop_content">
                <Aside activeTab={activeTab} setActiveTab={setActiveTab} />
              </div>
              <div className="col-lg-8 col-md-8 in-mobile">
                <div className="tabs">
                  <div className="tab_content">
                    <div className="tab-content" id="v-pills-tabContent">
                      <div
                        className=""
                        id="v-pills-editProfile"
                        role="tabpanel"
                        aria-labelledby="v-pills-editProfile-tab"
                        tabIndex="0"
                      >
                        <Formik
                          enableReinitialize
                          initialValues={{
                            email: customerDetailsData?.email
                              ? customerDetailsData?.email
                              : "",
                            mobile: customerDetailsData?.mobile
                              ? "+" + customerDetailsData?.mobile
                              : "",
                            firstname: customerDetailsData?.firstname
                              ? customerDetailsData?.firstname
                              : "",
                            lastname: customerDetailsData?.lastname
                              ? customerDetailsData?.lastname
                              : "",
                            dob:
                              customerDetailsData?.extended_fields?.field
                                ?.length > 0
                                ? getFieldsValue(
                                    customerDetailsData?.extended_fields?.field,
                                    "dob_date"
                                  )
                                : "",
                            gender:
                              customerDetailsData?.extended_fields?.field
                                ?.length > 0
                                ? getFieldsValue(
                                    customerDetailsData?.extended_fields?.field,
                                    "gender"
                                  )?.toLowerCase()
                                : "",
                            address1:
                              customerDetailsData?.custom_fields?.field
                                ?.length > 0
                                ? getFieldsValue(
                                    customerDetailsData?.custom_fields?.field,
                                    "address_1"
                                  )
                                : "",
                            // address2:
                            //   customerDetailsData?.custom_fields?.field
                            //     ?.length > 0
                            //     ? getFieldsValue(
                            //         customerDetailsData?.custom_fields?.field,
                            //         "address_2"
                            //       )
                            //     : "",
                            state:
                              customerDetailsData?.extended_fields?.field
                                ?.length > 0
                                ? getFieldsValue(
                                    customerDetailsData?.extended_fields?.field,
                                    "state"
                                  )
                                : "",
                            pincode:
                              customerDetailsData?.custom_fields?.field
                                ?.length > 0
                                ? getFieldsValue(
                                    customerDetailsData?.custom_fields?.field,
                                    "pin_code"
                                  )
                                : "",
                            // addressType:
                            //   customerDetailsData?.custom_fields?.field
                            //     ?.length > 0
                            //     ? getFieldsValue(
                            //         customerDetailsData?.custom_fields?.field,
                            //         "address_type"
                            //       )
                            //     : "",
                          }}
                          validationSchema={validationSchema}
                          // root: {
                          //   customer: [
                          //     {
                          //       mobile: getMobile(),
                          //       firstname: customerData.firstname,
                          //       lastname: customerData.lastname,
                          //       email: customerData.email,
                          //       custom_fields: {
                          //         field: newCustomFields, // Use the updated custom fields array
                          //       },
                          //     },
                          //   ],
                          // },
                          onSubmit={async (values) => {
                            const data = {
                              root: {
                                customer: [
                                  {
                                    firstname: values.firstname,
                                    lastname: values.lastname,
                                    email: values.email,
                                    mobile: localStorage.getItem("mobile"),
                                    extended_fields: {
                                      field: [
                                        {
                                          name: "State",
                                          value: values.state,
                                        },

                                        {
                                          name: "gender",
                                          value: values.gender,
                                        },

                                        {
                                          name: "pin_code",
                                          value: values.pincode,
                                        },

                                        {
                                          name: "address_1",
                                          value: values.address1,
                                        },
                                        // {
                                        //   name: "address_2",
                                        //   value: values.address2,
                                        // },
                                        // {
                                        //   name: "address_Type",
                                        //   value: values.addressType,
                                        // },
                                        {
                                          name: "dob_date",
                                          value: moment(values.dob).format(
                                            "YYYY-MM-DD"
                                          ),
                                        },
                                      ],
                                    },

                                    custom_fields: {
                                      field: [
                                        {
                                          name: "pin_code",
                                          value: values.pincode,
                                        },

                                        {
                                          name: "address_1",
                                          value: values.address1,
                                        },
                                        // {
                                        //   name: "address_2",
                                        //   value: values.address2,
                                        // },
                                        // {
                                        //   name: "address_Type",
                                        //   value: values.addressType,
                                        // },
                                      ],
                                    },
                                  },
                                ],
                              },
                            };

                            const result = await dispatch(
                              updateCustomerCall(data)
                            );
                            // console.log(result, "Result");
                            if (
                              result?.payload?.response?.status?.success ===
                                "true" ||
                              result?.payload?.response?.status?.success ===
                                true
                            ) {
                              toast.success("Profile updated successfully");
                              setIsDOBPresent(true);
                            } else {
                              toast.error("Failed to update customer");
                            }
                            // Add your submission logic here
                          }}
                        >
                          {({
                            values,
                            errors,
                            touched,
                            setFieldValue,
                            handleSubmit,
                          }) => (
                            <Form
                              className="edit-parent"
                              onSubmit={handleSubmit}
                            >
                              <div className="top-patch">
                                <div className="container pt-5 in-mobile mobile_content">
                                  <Breadcrumbs
                                    separator={
                                      <NavigateNextIcon
                                        fontSize="small"
                                        sx={{ color: "#A9A9A9" }}
                                      />
                                    }
                                    aria-label="breadcrumb"
                                  >
                                    {breadcrumbsMobile}
                                  </Breadcrumbs>
                                </div>
                              </div>
                              <div className="content-container">
                                <div className="image-container">
                                  <img
                                    src={user_Icon}
                                    alt="user icon"
                                    width={120}
                                  />
                                  {/* <div className="camera-container">
                                    <img
                                      src={camera_Icon}
                                      alt="camera icon"
                                      width={40}
                                    />
                                  </div> */}
                                </div>
                                <h2 className="greeting">
                                  Hi, {customerDetailsData?.firstname}{" "}
                                  {customerDetailsData?.lastname}
                                </h2>
                              </div>

                              <div className="account-container">
                                <div className="account-title">
                                  <h5>Account details</h5>
                                </div>
                                <div className="account-details">
                                  <div className="field-container">
                                    <h5 className="label">Email ID</h5>
                                    <div className="input-container">
                                      <Field
                                        type="email"
                                        className={`filled-input ${
                                          errors.email && touched.email
                                            ? "border-red"
                                            : ""
                                        }`}
                                        name="email"
                                        id="email"
                                        placeholder=""
                                      />
                                      <label
                                        htmlFor="email"
                                        className="filled-label"
                                      >
                                        Email ID
                                      </label>
                                      {/* <button
                                        type="button"
                                        className="verify-button"
                                      >
                                        Verify Email
                                      </button> */}
                                      <ErrorMessage
                                        name="email"
                                        component="div"
                                        className="error-message"
                                      />
                                    </div>
                                  </div>
                                  <div className="field-container">
                                    <h5 className="label">
                                      Mobile Number
                                      {/* <span className="required">*</span> */}
                                    </h5>
                                    <div className="input-container">
                                      <Field
                                        type="tel"
                                        className={`filled-input input ${
                                          errors.mobile && touched.mobile
                                            ? "border-red"
                                            : ""
                                        }`}
                                        name="mobile"
                                        id="mobile"
                                        placeholder=""
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          if (value.startsWith("+91")) {
                                            setFieldValue("mobile", value);
                                          } else if (value.length <= 3) {
                                            setFieldValue("mobile", "+91");
                                          } else {
                                            setFieldValue(
                                              "mobile",
                                              "+91" + value.replace(/^\+91/, "")
                                            );
                                          }
                                        }}
                                        disabled={true}
                                      />
                                      <label
                                        htmlFor="mobile"
                                        className="label2"
                                      >
                                        Mobile Number
                                      </label>
                                      <img
                                        src={flag}
                                        alt="flag icon"
                                        className="flag"
                                      />
                                      <ErrorMessage
                                        name="mobile"
                                        component="div"
                                        className="error-message"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="personal-container">
                                <div className="account-title">
                                  <h5>Personal details</h5>
                                </div>
                                <div className="account-details">
                                  <div className="field-container">
                                    <h5 className="label">
                                      First Name{" "}
                                      {/* <span className="required">*</span> */}
                                    </h5>
                                    <div className="input-container">
                                      <Field
                                        type="text"
                                        className={`filled-input ${
                                          errors.firstname && touched.firstname
                                            ? "border-red"
                                            : ""
                                        }`}
                                        name="firstname"
                                        id="firstname"
                                        placeholder=""
                                      />
                                      <label
                                        htmlFor="firstname"
                                        className="filled-label"
                                      >
                                        First Name
                                      </label>
                                      <ErrorMessage
                                        name="firstname"
                                        component="div"
                                        className="error-message"
                                      />
                                    </div>
                                  </div>
                                  <div className="field-container">
                                    <h5 className="label">
                                      Last Name{" "}
                                      {/* <span className="required">*</span> */}
                                    </h5>
                                    <div className="input-container">
                                      <Field
                                        type="text"
                                        className={`filled-input ${
                                          errors.lastname && touched.lastname
                                            ? "border-red"
                                            : ""
                                        }`}
                                        name="lastname"
                                        id="lastname"
                                        placeholder=""
                                      />
                                      <label
                                        htmlFor="lastname"
                                        className="filled-label"
                                      >
                                        Last Name
                                      </label>
                                      <ErrorMessage
                                        name="lastname"
                                        component="div"
                                        className="error-message"
                                      />
                                    </div>
                                  </div>

                                  <div className="field-container">
                                    <h5 className="label">Date of Birth</h5>
                                    <div className="input-container">
                                      {/* <Field
                                        type="date"
                                        className="filled-input"
                                        name="dob"
                                        id="dob"
                                        placeholder=""
                                      /> */}
                                      <div
                                        className={`filled-input filled-input2 ${
                                          errors.dob && touched.dob
                                            ? "border-red"
                                            : ""
                                        }`}
                                      >
                                        <CustomDatePicker
                                          setFieldValue={setFieldValue}
                                          dateValue={values.dob}
                                          disabled={isDOBPresent}
                                        />
                                        <img
                                          src={calendarIocn}
                                          alt="calendar icon"
                                          className="mobile_content cal"
                                        />
                                      </div>
                                      <label
                                        htmlFor="date"
                                        className={`${
                                          values.dob === "" || !values.dob
                                            ? "label3"
                                            : "label2"
                                        }`}
                                      >
                                        dd/mm/yyyy
                                      </label>
                                      <ErrorMessage
                                        name="dob"
                                        component="div"
                                        className="error-message"
                                      />
                                    </div>
                                  </div>

                                  <div className="field-container">
                                    <h5 className="label">Gender</h5>
                                    <div className="input-container gender-options">
                                      <div className="option">
                                        <Field
                                          type="radio"
                                          id="male"
                                          name="gender"
                                          value="male"
                                        />
                                        <label
                                          htmlFor="male"
                                          className="gender-label"
                                        >
                                          Male
                                        </label>
                                      </div>
                                      <div className="option">
                                        <Field
                                          type="radio"
                                          id="female"
                                          name="gender"
                                          value="female"
                                        />
                                        <label
                                          htmlFor="female"
                                          className="gender-label"
                                        >
                                          Female
                                        </label>
                                      </div>
                                      <ErrorMessage
                                        name="gender"
                                        component="div"
                                        className="error-message error2"
                                      />
                                    </div>
                                  </div>
                                  <div className="field-container">
                                    <h5 className="label">
                                      Address Line{" "}
                                      {/* <span className="required">*</span> */}
                                    </h5>
                                    <div className="input-container">
                                      <Field
                                        type="text"
                                        className={`filled-input ${
                                          errors.address1 && touched.address1
                                            ? "border-red"
                                            : ""
                                        }`}
                                        name="address1"
                                        id="address1"
                                        placeholder=""
                                      />
                                      <label
                                        htmlFor="address1"
                                        className="filled-label"
                                      >
                                        Address Line
                                      </label>
                                      <ErrorMessage
                                        name="address1"
                                        component="div"
                                        className="error-message"
                                      />
                                    </div>
                                  </div>
                                  {/* <div className="field-container">
                                    <h5 className="label">
                                      Address Line 2{" "}
                                      <span className="required">*</span>
                                    </h5>
                                    <div className="input-container">
                                      <Field
                                        type="text"
                                        className={`filled-input ${
                                          errors.address2 && touched.address2
                                            ? "border-red"
                                            : ""
                                        }`}
                                        name="address2"
                                        id="address2"
                                        placeholder=""
                                      />
                                      <label
                                        htmlFor="address2"
                                        className="filled-label"
                                      >
                                        Address Line 2
                                      </label>
                                      <ErrorMessage
                                        name="address2"
                                        component="div"
                                        className="error-message"
                                      />
                                    </div>
                                  </div> */}
                                  <div className="field-container">
                                    <h5 className="label">
                                      State
                                      {/* <span className="required">*</span> */}
                                    </h5>
                                    <div className="input-container">
                                      <div
                                        className={`filled-input filled-input2 ${
                                          errors.state && touched.state
                                            ? "border-red"
                                            : ""
                                        }`}
                                      >
                                        <Field
                                          as="select"
                                          name="state"
                                          className="filled-input filled-input3"
                                          defaultValue=""
                                        >
                                          <option value="">Select State</option>
                                          {states.map((state) => (
                                            <option
                                              key={state.name}
                                              value={state.name}
                                            >
                                              {state.name}
                                            </option>
                                          ))}
                                        </Field>
                                      </div>
                                      <ErrorMessage
                                        name="state"
                                        component="div"
                                        className="error-message"
                                      />
                                    </div>
                                  </div>
                                  <div className="field-container">
                                    <h5 className="label">
                                      Pin Code{" "}
                                      {/* <span className="required">*</span> */}
                                    </h5>
                                    <div className="input-container">
                                      <Field
                                        type="text"
                                        className={`filled-input ${
                                          errors.pincode && touched.pincode
                                            ? "border-red"
                                            : ""
                                        }`}
                                        name="pincode"
                                        id="pincode"
                                        placeholder=""
                                        maxLength={6} // Limit input to 6 characters
                                        onInput={(e) => {
                                          // Allow only numeric input
                                          e.target.value =
                                            e.target.value.replace(
                                              /[^0-9]/g,
                                              ""
                                            );
                                        }}
                                      />
                                      <label
                                        htmlFor="pincode"
                                        className="filled-label"
                                      >
                                        Pin Code
                                      </label>
                                      {/* <button
                                        type="button"
                                        className="locate-button"
                                      >
                                        <img
                                          src={LocateIcon}
                                          alt="Locate icon"
                                          width={18}
                                        />
                                        <span className="locate-text">
                                          Locate Me
                                        </span>
                                      </button> */}
                                      <ErrorMessage
                                        name="pincode"
                                        component="div"
                                        className="error-message"
                                      />
                                    </div>
                                  </div>
                                  {/* <div className="field-container">
                                    <h5 className="label">Address Type</h5>
                                    <div className="input-container address-type-options">
                                      <div className="option">
                                        <Field
                                          type="radio"
                                          id="home"
                                          name="addressType"
                                          value="home"
                                        />
                                        <label
                                          htmlFor="home"
                                          className="address-label"
                                        >
                                          Home
                                        </label>
                                      </div>
                                      <div className="option">
                                        <Field
                                          type="radio"
                                          id="work"
                                          name="addressType"
                                          value="work"
                                        />
                                        <label
                                          htmlFor="work"
                                          className="address-label"
                                        >
                                          Work
                                        </label>
                                      </div>
                                      <div className="option">
                                        <Field
                                          type="radio"
                                          id="others"
                                          name="addressType"
                                          value="others"
                                        />
                                        <label
                                          htmlFor="others"
                                          className="address-label"
                                        >
                                          Others
                                        </label>
                                      </div>
                                      <ErrorMessage
                                        name="addressType"
                                        component="div"
                                        className="error-message error2"
                                      />
                                    </div>
                                  </div> */}
                                </div>
                              </div>

                              <div className="save-button-container">
                                <button type="submit" className="save-button">
                                  Save Details {loading ? <Spinner /> : null}
                                </button>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div
                      className="modal fade"
                      id="staticBackdrop"
                      data-bs-backdrop="static"
                      data-bs-keyboard="false"
                      tabIndex="-1"
                      aria-labelledby="staticBackdropLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-dialog-centered">
                        <div className="d-flex">
                          <div className="modal-content">
                            <div className="custom_div">
                              <button
                                type="button"
                                className="btn-close"
                                data-bs-toggle="modal"
                                data-bs-target="#staticBackdrop"
                                data-bs-dismiss="modal"
                              >
                                <img
                                  src={closeIcon}
                                  alt="close icon"
                                  data-bs-dismiss="modal"
                                />
                              </button>
                            </div>
                            <div className="modal-body">
                              <h1>Invite Members</h1>
                              <form action="">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <label
                                      htmlFor="staticEmail"
                                      className="col-sm-2 col-form-label"
                                    >
                                      Email
                                    </label>
                                  </div>
                                  <div className="col-lg-6">
                                    <input
                                      type="password"
                                      className="form-control"
                                      id="inputPassword"
                                    />
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>

                          {/* <img src={closeIcon} type="button" className="btn-close" data-bs-toggle="modal" data-bs-target="#staticBackdrop" alt="" /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer2 selected="home" />
    </>
  );
};

export default EditProfile;
